<script setup>
/* eslint-disable no-new */
import MultiClamp from 'multi-clamp'
import { defineProps, onMounted, ref } from 'vue'

const clamped = ref(null)

const props = defineProps({
  maxLines: {
    type: Number,
    default: 3
  }
})

onMounted(() => {
  new MultiClamp(clamped.value, {
    ellipsis: '...',
    clamp: props.maxLines
  })
})
</script>
<template>
  <div
    ref="clamped"
  >
    <slot />
  </div>
</template>
